export default "/icons/Adobe_xd_icon.svg";